import { useQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useMyReactionsBatch } from '@/hooks/useMyReactionsBatch';

/**
 * The current user's kind-7 reaction to an event, or `null` when they haven't
 * reacted. Batched across all visible posts via MyReactionsProvider, so a
 * full feed costs ~1 relay round-trip instead of one per post.
 */
export function useMyReaction(eventId: string | undefined) {
  const { user } = useCurrentUser();
  const { load } = useMyReactionsBatch();

  return useQuery<NostrEvent | null>({
    queryKey: ['my-reaction', eventId ?? '', user?.pubkey ?? ''],
    queryFn: () => load(eventId!),
    enabled: !!eventId && !!user,
    staleTime: 30000,
  });
}
